import Axios, { CancelToken } from "axios";
import { BaseResponse } from "../types/Common.interface";

export interface AddressDto {
  id: string;
  unom: string;
  address: string;
  simpleAddress: string;
}

const AddressService = {
  search: (query: string, cancelToken?: CancelToken) =>
    Axios.get<BaseResponse<AddressDto[]>>(
      `/api/address/search?query=${query}`,
      { cancelToken }
    ).then(({ data }) => data),
};

export default AddressService;
